export const GET_ADMIN_MINUTES_REQUEST = "GET_ADMIN_MINUTES_REQUEST";
export const GET_ADMIN_MINUTES_SUCCESS = "GET_ADMIN_MINUTES_SUCCESS";
export const GET_ADMIN_MINUTES_FAIL = "GET_ADMIN_MINUTES_FAIL";

export const CREATE_ADMIN_MINUTES_REQUEST = "CREATE_ADMIN_MINUTES_REQUEST";
export const CREATE_ADMIN_MINUTES_SUCCESS = "CREATE_ADMIN_MINUTES_SUCCESS";
export const CREATE_ADMIN_MINUTES_FAIL = "CREATE_ADMIN_MINUTES_FAIL";

export const UPDATE_ADMIN_MINUTES_REQUEST = "UPDATE_ADMIN_MINUTES_REQUEST";
export const UPDATE_ADMIN_MINUTES_SUCCESS = "UPDATE_ADMIN_MINUTES_SUCCESS";
export const UPDATE_ADMIN_MINUTES_FAIL = "UPDATE_ADMIN_MINUTES_FAIL";

export const DELETE_ADMIN_MINUTES_REQUEST = "DELETE_ADMIN_MINUTES_REQUEST";
export const DELETE_ADMIN_MINUTES_SUCCESS = "DELETE_ADMIN_MINUTES_SUCCESS";
export const DELETE_ADMIN_MINUTES_FAIL = "DELETE_ADMIN_MINUTES_FAIL";

export const GET_ADMIN_BILLING_MINUTES_REQUEST = "GET_ADMIN_BILLING_MINUTES_REQUEST";
export const GET_ADMIN_BILLING_MINUTES_SUCCESS = "GET_ADMIN_BILLING_MINUTES_SUCCESS";
export const GET_ADMIN_BILLING_MINUTES_FAIL = "GET_ADMIN_BILLING_MINUTES_FAIL";

export const GET_ADMIN_TOTAL_MINUTES_REQUEST = "GET_ADMIN_TOTAL_MINUTES_REQUEST";
export const GET_ADMIN_TOTAL_MINUTES_SUCCESS = "GET_ADMIN_TOTAL_MINUTES_SUCCESS";
export const GET_ADMIN_TOTAL_MINUTES_FAIL = "GET_ADMIN_TOTAL_MINUTES_FAIL";